<svg
  width="18"
  height="19"
  viewBox="0 0 18 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.4873 14.3923L13.4223 10.6963C13.0233 10.3333 12.4073 10.3523 12.0313 10.7393L9.63828 13.2003C9.06228 13.0903 7.90428 12.7293 6.71228 11.5403C5.52028 10.3473 5.15928 9.18632 5.05228 8.61432L7.51128 6.22032C7.89928 5.84432 7.91728 5.22932 7.55428 4.82932L3.85928 0.765318C3.49628 0.364318 2.87928 0.326318 2.46828 0.678318L0.298282 2.53932C0.125282 2.71332 0.022282 2.94332 0.00828196 3.18832C-0.00671804 3.43832 -0.292718 9.36032 4.29928 13.9543C8.30528 17.9593 13.3233 18.2523 14.7053 18.2523C14.9073 18.2523 15.0313 18.2463 15.0643 18.2443C15.3093 18.2303 15.5393 18.1273 15.7123 17.9533L17.5723 15.7823C17.9263 15.3713 17.8873 14.7553 17.4873 14.3923Z"
    fill="currentColor"
  />
</svg>
